module.exports = __webpack_public_path__ + "img/coolmon-logo.c85f26bf.png";